import React from 'react'
import { Box } from '@mui/material'

import { ActionButton } from '../action-button'
import { ThemeButton } from '../theme-button'

/**
 * @typedef {object} CustomActionButtonsProps
 * @property {Array<object>} [iconButtons=[]] - Array de configuraciones para botones de ícono (ActionButton).
 * @property {Array<object>} [fullButtons=[]] - Array de configuraciones para botones completos (ThemeButton).
 */

/**
 * Contenedor flexible para botones de acción (íconos y completos).
 *
 * Renderiza dos grupos de botones: botones de ícono (ActionButton) alineados a la izquierda,
 * y botones completos (ThemeButton) alineados a la derecha. Soporta ocultación condicional
 * mediante la propiedad 'hidden' en cada botón.
 *
 * @component
 * @example
 * <CustomActionButtons
 *   iconButtons={[
 *     { icon: <EditIcon />, tooltip: 'Editar', onClick: handleEdit },
 *     { icon: <DeleteIcon />, tooltip: 'Eliminar', onClick: handleDelete, hidden: !canDelete }
 *   ]}
 *   fullButtons={[
 *     { label: 'Guardar', onClick: handleSave },
 *     { label: 'Cancelar', onClick: handleCancel }
 *   ]}
 * />
 *
 * @param {CustomActionButtonsProps} props - Las props del componente CustomActionButtons.
 */
export const CustomActionButtons = ({ iconButtons = [], fullButtons = [] }) => {
  return (
    <Box display="flex" flexWrap="wrap" width="100%">
      {iconButtons.length ? (
        <Box display="flex" flexGrow={2} flexWrap="wrap">
          {iconButtons.map((button, i) =>
            !button['hidden'] ? <ActionButton key={i} {...button} /> : null
          )}
        </Box>
      ) : null}
      {fullButtons.length ? (
        <Box display="flex" flexGrow={0.5} justifyContent="flex-end">
          {fullButtons.forEach((button, i) => {
            return (
              <ThemeButton key={i} {...button} color="primary" labelM="sm">
                {button.label}
              </ThemeButton>
            )
          })}
        </Box>
      ) : null}
    </Box>
  )
}
